import * as React from "react";
import {
  displayGroupRole,
  displayName,
} from "../../../../application/domain/rbac/rbac";
import { UserEntity } from "../../../../application/domain/user/user-entity";
import { RBACButton } from "../../../molecules/rbac-button";
import { Group } from "../../../../application/domain/group/group";
import { ToggleTag } from "../../common/toggle-tag";

type UserPreviewProps = {
  user: UserEntity;
  setIsEdit: React.Dispatch<React.SetStateAction<boolean>>;
  groups: Group[];
  shouldSelectGroup: boolean;
  isSamlAuthEnabled: boolean;
};

export const UserView: React.FC<UserPreviewProps> = ({
  user,
  setIsEdit,
  groups,
  shouldSelectGroup,
  isSamlAuthEnabled,
}) => (
  <section className="c-use-detail__section">
    <nav className="level">
      <div className="level-left">
        <h1 className="title is-size-4 mb-4">基本情報</h1>
      </div>
      <div className="level-right">
        <RBACButton
          requirePermissions="users.update"
          onClick={() => setIsEdit(true)}
          buttonTypes="primary"
          buttonText="編集"
        />
      </div>
    </nav>
    <div className="field">
      <h2 className="has-text-weight-bold">氏名</h2>
      <div className="control">
        <p>{user.name} </p>
      </div>
    </div>
    <div className="field">
      <h2 className="has-text-weight-bold">アカウント名</h2>
      <div className="control">
        <p>{user.accountName}</p>
      </div>
    </div>
    <div className="field">
      <h2 className="has-text-weight-bold">ロール</h2>
      <div className="control">
        {user.roles.map((role) => (
          <p key={role}>{displayName(role)}</p>
        ))}
      </div>
    </div>
    {/* 「Admin以外でグループ未所属のユーザー」がstagingに残っているため、user.groupsRolesの中身を意図的に確認している */}
    {shouldSelectGroup && Object.keys(user.groupsRoles).length > 0 && (
      <div className="field">
        <h2 className="has-text-weight-bold">グループ・グループロール</h2>
        <ul className="control">
          {groups
            .filter((group) => user.groupsRoles[group.id!] !== undefined)
            .map((group) => {
              return (
                <li key={group.id}>
                  {group.name}&nbsp;:&nbsp;
                  {displayGroupRole(user.groupsRoles[group.id!])}
                </li>
              );
            })}
        </ul>
      </div>
    )}
    <div className="field">
      <h2 className="has-text-weight-bold">2段階認証</h2>
      <div className="control">{user.isTOTPEnabled() ? "ON" : "OFF"}</div>
    </div>
    <div className="field">
      <h2 className="has-text-weight-bold">メールアドレス</h2>
      <div>
        <p>{user.email || "未設定"}</p>
      </div>
    </div>
    <div className="field">
      <h2 className="has-text-weight-bold">ユーザーステータス</h2>
      <div className="control">
        <div className="has-addons">
          <ToggleTag disabled={user.disabled} />
        </div>
      </div>
    </div>
    {isSamlAuthEnabled && (
      <>
        <div className="field">
          <h2 className="has-text-weight-bold">認証方法</h2>
          <div className="control">
            <div className="has-addons">
              <p>
                {user.authMethod === "password" ? "パスワード認証" : "SAML認証"}
              </p>
            </div>
          </div>
        </div>
        {user.authMethod === "saml" && (
          <div className="field">
            <h2 className="has-text-weight-bold">外部ユーザーID</h2>
            <div className="control">
              <div className="has-addons">
                <p>{user.externalUserId}</p>
              </div>
            </div>
          </div>
        )}
      </>
    )}
  </section>
);
